(function() {
  'use strict';
  if (window.AeroCartNotificationTerms) return;
  window.AeroCartNotificationTerms = class AeroCartNotificationTerms {
  constructor() {
    this.checkoutButton = document.querySelector('#cart-notification-checkout');
    this.termsCheckbox = document.querySelector('#cart-notification-terms-checkbox');
    this.termsTooltip = document.querySelector('#cart-notification-terms-tooltip');
    this.termsModal = document.querySelector('#cart-notification-terms-modal');
    this.termsModalOkButton = document.querySelector('#cart-notification-terms-modal-ok');
    this.cartForm = document.querySelector('#cart-notification-form');
    
    if (this.checkoutButton && this.termsCheckbox) {
      this.init();
    }
  }

  init() {
    // Disable checkout button initially
    this.disableCheckoutButton();
    
    // Add event listeners
    this.termsCheckbox.addEventListener('change', () => this.handleCheckboxChange());
    this.checkoutButton.addEventListener('click', (e) => this.handleCheckoutClick(e));
    
    // Prevent form submission if terms not accepted
    if (this.cartForm) {
      this.cartForm.addEventListener('submit', (e) => {
        if (!this.termsCheckbox.checked) {
          e.preventDefault();
          this.showModal();
        }
      });
    }
    
    // Add hover event listeners for checkout button
    this.checkoutButton.addEventListener('mouseenter', () => {
      if (!this.termsCheckbox.checked) {
        this.showTooltip();
      }
    });
    this.checkoutButton.addEventListener('mouseleave', () => this.hideTooltip());

    // Modal event listener
    this.termsModalOkButton.addEventListener('click', () => this.hideModal());
  }

  handleCheckboxChange() {
    if (this.termsCheckbox.checked) {
      this.enableCheckoutButton();
      this.hideTooltip();
    } else {
      this.disableCheckoutButton();
    }
  }

  handleCheckoutClick(e) {
    if (!this.termsCheckbox.checked) {
      e.preventDefault();
      e.stopPropagation();
      this.showModal();
    }
  }

  showTooltip() {
    if (!this.termsCheckbox.checked) {
      this.termsTooltip.style.display = 'block';
    }
  }

  hideTooltip() {
    this.termsTooltip.style.display = 'none';
  }

  showModal() {
    this.termsModal.style.display = 'flex';
  }

  hideModal() {
    this.termsModal.style.display = 'none';
  }

  disableCheckoutButton() {
    if (this.checkoutButton) {
      this.checkoutButton.disabled = true;
      this.checkoutButton.setAttribute('aria-disabled', 'true');
    }
  }

  enableCheckoutButton() {
    if (this.checkoutButton) {
      this.checkoutButton.disabled = false;
      this.checkoutButton.removeAttribute('aria-disabled');
    }
  }
  };

  // Initialize when DOM is loaded (only once)
  document.addEventListener('DOMContentLoaded', () => {
    new window.AeroCartNotificationTerms();
  });
})(); 